import React, { useState, useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { JLLHeader, JLLFooter, Sidebar } from './index';
import { LAYOUT } from '../../utils/layoutConstants';

const COLLAPSE_PATTERN = /^\/(preview|filters|cards|dashboard)\/[^/]+|^\/survey\/[^/]+\/(edit|preview)/;
const SIDEBAR_AUTO_COLLAPSE_MAX_WIDTH = 1024;

const AppLayout = ({ children }) => {
  const location = useLocation();
  const isSmallScreen = () => window.innerWidth <= SIDEBAR_AUTO_COLLAPSE_MAX_WIDTH;
  const [sidebarOpen, setSidebarOpen] = useState(
    () => !COLLAPSE_PATTERN.test(location.pathname) && !isSmallScreen()
  );
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    const wasCollapseRoute = COLLAPSE_PATTERN.test(prevPathRef.current);
    const isCollapseRoute = COLLAPSE_PATTERN.test(location.pathname);
    prevPathRef.current = location.pathname;

    if (isCollapseRoute && !wasCollapseRoute) {
      setSidebarOpen(false);
    } else if (!isCollapseRoute && wasCollapseRoute) {
      setSidebarOpen(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      if (isSmallScreen()) {
        setSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSidebarToggle = () => {
    setSidebarOpen((prev) => !prev);
  };

  const sidebarWidth = sidebarOpen ? LAYOUT.SIDEBAR_WIDTH : LAYOUT.SIDEBAR_WIDTH_COLLAPSED;

  useEffect(() => {
    document.documentElement.style.setProperty('--sidebar-width', `${sidebarWidth}px`);
  }, [sidebarWidth]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <JLLHeader sidebarOpen={sidebarOpen} />
      <Box sx={{ display: 'flex', flex: 1, pt: `${LAYOUT.HEADER_HEIGHT}px`, width: '100%', pb: `${LAYOUT.FOOTER_HEIGHT}px` }}>
        <Sidebar open={sidebarOpen} onToggle={handleSidebarToggle} />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            backgroundColor: 'transparent',
            minHeight: `calc(100vh - ${LAYOUT.HEADER_HEIGHT}px - ${LAYOUT.FOOTER_HEIGHT}px)`,
            transition: 'all 0.3s ease',
            margin: 0,
            padding: 0,
            overflow: 'auto',
            position: 'relative',
            boxSizing: 'border-box',
            width: `calc(100% - ${sidebarWidth}px)`,
            maxWidth: 'none',
          }}
        >
          {children}
        </Box>
      </Box>
      <JLLFooter sidebarOpen={sidebarOpen} />
    </Box>
  );
};

export default AppLayout;
